import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: 'classify',
directives: {
TransferDom
},
components: {
XHeader,
XButton,
Popup
},
data () {
return {
showMenus: false,
navBarData: ['工业', '饰品', '艺术', '生活创意', '人物角色', '等比例模型', '玩具', '其它'],
classifyData: ['汽车', '表面处理类型', '机械零件', '机器人', '其他'],
isActive: 0,
classifyName: '工业'
}
},
methods: {
toggleActive (index, item) {
this.isActive = index
this.classifyName = item
},
afterClassify (index, item) {
console.log(item)
this.$router.push({
path: '/afterClassify'
})
}
},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/classify/script.js